import React, { useState, useEffect } from 'react';
import { renderPost } from '../api/index';
import { useParams } from 'react-router-dom';
import "../css/Michels.css"
import PDFUpload from './PDFUpload';
import DeletePost from './DeletePost';
import { useNavigate } from 'react-router-dom';

const Post = () => {
    const { short_title } = useParams();
    const [post, setPost] = useState(null);
    let navigate = useNavigate();

    function transformYouTubeLinks(htmlContent) {
        const youtubeLinkRegex = /<a href="https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)"[^>]*>(.*?)<\/a>/g;
    
        return htmlContent.replace(youtubeLinkRegex, (match, videoId, linkText) => {
            return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        });
    }

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await renderPost(short_title);
                const transformedContent = transformYouTubeLinks(response.data.content);
                console.log(transformedContent, response.data.content);
                setPost({ ...response.data, content: transformedContent });
            } catch (error) {
                console.error('Error fetching post:', error);
                if (error.response.data.message == 'User not payed')
                {
                    navigate('/pay');
                }
            }
        };
        
        fetchPost();
    }, [short_title]);

    if (!post) return <div>Loading...</div>;

    return (
        <div className='Michels'>
            <div className='Michels-text'>
                <h1 id='essayTitle'>{post.title}</h1>
                <div 
                    className="post-content"
                    dangerouslySetInnerHTML={{ __html: post.content }} 
                />
                <PDFUpload short_title={short_title}/>
                <DeletePost short_title={short_title}/>
            </div>
        </div>
    );
}

export default Post;
